import React, { useState } from "react";
import { t } from "ttag";
import { Button, Checkbox, Typography } from "@coolremote/shared";
import TOU from "../../screens/Dashboard/TOU";
import { useStoreActions } from "../../models/RootStore";
import styles from "./MobileTermsOfUseAgreement.module.css";

/**
 * Mobile equivalent of the Terms-of-Use gate the desktop Dashboard already
 * shows (src/screens/Dashboard/Dashboard.tsx) — ports the same isAcceptedTOU
 * check and acceptTOU action to the mobile Dashboard (CM-752), mirroring the
 * scroll-then-accept screen the sibling Control app shows on first login.
 */
const MobileTermsOfUseAgreement: React.FC = () => {
  const acceptTOU = useStoreActions((actions) => actions.users.acceptTOU);
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleToggleAccepted = () => {
    setAccepted(!accepted);
  };

  const handleAccept = () => {
    if (!accepted) {
      return;
    }
    acceptTOU()
      .then(() => setError(null))
      .catch((err: any) => setError(err.message));
  };

  return (
    <div className={styles.screen}>
      <div className={styles.appBar}>
        <span className={styles.appBarTitle}>{t`Terms Of Use`}</span>
      </div>

      <div className={styles.instructions}>
        <Typography variant="body2">
          {t`Scroll down and confirm you have read and accept the below terms of use`}
        </Typography>
      </div>

      <div className={styles.content}>
        <TOU />
      </div>

      <div className={styles.footer}>
        {error && (
          <Typography variant="body2" className={styles.errorText}>
            {error}
          </Typography>
        )}
        <div className={styles.acceptRow}>
          <Checkbox checked={accepted} onChange={handleToggleAccepted} />
          <Typography variant="body2">{t`I have read and accept the terms of use`}</Typography>
        </div>
        <Button variant="contained" disabled={!accepted} onClick={handleAccept}>
          {t`Done`}
        </Button>
      </div>
    </div>
  );
};

export default MobileTermsOfUseAgreement;
